const SPECIAL_CHARS_REGEXP = /[^\p{L}\s'-]/ug;
const MULTIPLE_SPACES_REGEXP = /\s+/g;

export const parseName = (name) => name
  .replace(SPECIAL_CHARS_REGEXP, '')
  .replace(MULTIPLE_SPACES_REGEXP, ' ')
  .trim();
